import { MatDialogConfig } from '@angular/material/dialog';

export const ROLES_DIALOG_CONFIG: MatDialogConfig = {
  panelClass: 'roles-dialog-panel',
  width: '808px',
  maxWidth: '808px',
  autoFocus: false,
  restoreFocus: false,
};
